import Route from '@ember/routing/route';

export default class MyItemsRoute extends Route {}
